<script setup lang="ts">
import { computed, type PropType } from 'vue';
import { type FormField } from '@/models';
import {
  type EffectConfig,
  type DisableConfig,
  type RequiredConfig,
  type Effects,
  setupEffects
} from '@/components';
import { useFormBuilder } from '@/stores/formBuilder';

const builder = useFormBuilder();

const props = defineProps({
  field: {
    type: Object as PropType<FormField>,
    required: true
  }
});

const effects = computed<Effects>(() => {
  return setupEffects(props.field, builder.form!.items!);
});

</script>

<template>
    <div class="effect visibility" v-if="(effects.Show as EffectConfig).conditions.length > 0">
        <FontAwesomeIcon :icon="[`fas`, `eye`]" class="icon"/>
        <div class="label">Visibility</div>
    </div>
    <div class="effect warning" v-if="(effects.Warn as EffectConfig).conditions.length > 0">
        <FontAwesomeIcon :icon="[`fas`, `exclamation-triangle`]" class="icon"/>
        <div class="label">Warning</div>
    </div>
    <div class="effect required" v-if="(effects.Required as RequiredConfig).strictness != 'None'">
        <FontAwesomeIcon :icon="[`fas`, `asterisk`]" class="icon"/>
        <div class="label">Required</div>
    </div>
    <div class="effect valid" v-if="(effects.Valid as EffectConfig).conditions.length > 0">
        <FontAwesomeIcon :icon="[`fas`, `do-not-enter`]" class="icon"/>
        <div class="label">Validation</div>
    </div>
    <div class="effect disable" v-if="(effects.Disable as DisableConfig).disable">
        <FontAwesomeIcon :icon="[`fas`, `ban`]" class="icon"/>
        <div class="label">Disable</div>
    </div>
    <div class="effect assign" v-if="(effects.Assign as EffectConfig).conditions.length > 0">
        <FontAwesomeIcon :icon="[`fal`, `calculator-simple`]" class="icon"/>
        <div class="label">Calculation</div>
    </div>
</template>

<style scoped lang="scss">
.effect {
  display: flex;
  align-items: center;
  padding: 8px;
  margin: 8px 0 8px 0;
  max-width: 132px;
  font-size: 14px;
  font-weight: 600;
  line-height: 4px;
  border: 1px solid transparent;
  border-radius: 4px;
}
.label {
  margin-left: 8px;
}
.visibility {
  border-color: #4e1f99;
  background-color: rgba(78, 31, 153, 0.06);
}
.warning {
  border-color: #fa8e00;
  background-color: #fff9f2;
}
.valid {
  border-color: #ea3546;
  background-color: #fef5f6;
}
.disable {
  border-color: #828e99;
  background-color: #f5f7fa;
}
.required {
  border-color: #1E90FF;
  background-color: #f5f7fa;
}
.assign {
  border-color: #8ef998;
  background-color: rgba(72, 251, 72, 0.1);
}
</style>
